module.exports = __webpack_public_path__ + "img/leader.fd9fef45.svg";